import { Component } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-restpass',
  templateUrl: './restpass.component.html',
  styleUrls: ['./restpass.component.css']
})
export class Restpass1Component extends FormSessionCanDeactivate {

  invalidpass: any;
  dateformat: string;
  bsConfig: { containerClass: string; showWeekNumbers: boolean; dateInputFormat: any; };
  currentUser: any;
  imageURL: any;
  question: any = [];
  public selectques = [];
  public selectques1 = [];
  secQuestionOne: any = '';
  secQuestionThree: any = '';
  secQuestionTwo: any = '';
  secQusAnswerOne: any
  secQusAnswerThree: any
  secQusAnswerTwo: any
  public timealert = environment.timelimit;
  showloader: boolean;
  public data: Object;
  public params: any;
  public pasd: any = {};
  newonepassword = '';
  newtwopassword = '';
  errormsgpass = '';
  public carepath: any = {};
  public myobj1: any = {};
  apiurl = environment.api_url;
  public Patp: any = {
    newpass: "",
    newpass2: ""
  };
  passval: boolean = false;
  passval1: boolean = false;
  passval2: boolean = false;
  passval3: boolean = false;
  passval4: boolean = false;
  passkey: boolean = false;
  passkey1: boolean = false;
  passkey2: boolean = false;
  passkey3: boolean = false;
  passkey4: boolean = false;
  passwordTyoe: boolean = false;
  resetPass: boolean = false;
  password: any;
  patvalue: any = {};
  resdata: any;
  show: any;
  patterns: any = "(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z*$-+?_&=!#@%{}/'.]*$";
  userGroup: boolean = true;
  public Select = {
    quest1: "",
    quest2: "",
    quest3: "",
    answer1: "",
    answer2: "",
    answer3: ""
  }
  patid: any;
  welcome: any;


  public myobj: any = {};

  showAndroid: boolean = false;
  stepAndroid: boolean;
  resetdata: string;
  userpass: any;
  useremail: any;
  patswfid: any;

  constructor(
    private routers: Router,
    private patientservice: PatientService,
    private modalService: BsModalService,
    private router: Router,
    private toast: ToastrService,
    private Userservice: UserService,
    private translate: TranslateService
  ) {
    super();
    this.translate.setDefaultLang(Userservice.defaultLang);
  }

  ngOnInit() {
    this.Userservice.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.currentUser.status = true;
        if (this.currentUser.item) {
          if (!this.currentUser.item.credResetRequired)
            this.currentUser.item.credResetRequired = false
          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.currentUser.item.userGroupId != 19 && this.currentUser.item.userGroupId != 20) {
            this.userGroup = false
            this.patterns = "(?=^.{8,32}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*"
          } else {
            this.userGroup = true
            this.patterns = "(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z*$-+?_&=!#@%{}/'.]*$"
          }
          if (this.currentUser.item.tempPasswordActive || this.currentUser.item.credResetRequired)
            this.resetPass = true
          this.getpassword();
        }
      });

    if (this.currentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    if (navigator.userAgent.search("Android") != -1) {
      this.showAndroid = true;
      this.stepAndroid = false;
    }


    this.patientservice
      .getquestions()
      .subscribe(
        data => {
          if (data) {
            this.question = data;
            if (!this.currentUser.item.credResetRequired)
              this.getSecretQue();
            else
              this.changeques(this.Select.quest1, 0);
          }
        }
      );

  }

  // getuniquelist(event){

  //   this.selectques = _.reject(this.question,(o:any):any=>{
  //    return o.userSecQuestionsId == event
  //    })
  //    ////console.log(this.selectques)
  //   }
  //   getlist(event){

  //     this.selectques1 = _.reject(this.selectques,(o:any):any=>{
  //      return o.userSecQuestionsId == event
  //      })

  //      ////console.log(this.selectques1)
  //       }
  checkPwd(pas) {
    if (pas.target.value) {
      this.patientservice.chkPass(pas.target.value)
        .subscribe(
          data => {
            if (data[0].status == 'failure') {
              this.Patp.newpass = '';
              this.Patp.newpass2 = '';
              this.toast.error(data[0].message)
            }
          })
    }
  }
  logout() {
    // debugger
    //this.unRegister();
    /*    this.idleState = 'TIMED_OUT';
       this.timedOut = true; */

    /* if(this.status.reports){  */
    this.Userservice.logoutuser(this.currentUser.item.userAccountId)
    //this.progressBarPopup.close();
    /* } */
    this.Userservice.purgeAuth();
    //this.currentUser.status==false

    if (window.localStorage['plogin']) {
      var plogin = window.localStorage['plogin']
      window.localStorage.removeItem('plogin');
      //window.localStorage.clear()
      this.router.navigateByUrl('/plogin/' + plogin);

    } else {
      //this.currentUser.status==false
      //window.localStorage.clear()
      this.router.navigateByUrl('/login');
    }
    //this.resetTimeOut("init");


    /* this.idle.setAutoResume(AutoResume.notIdle);
    this.idle.watch() */
    /* alert(this.sessionService.getState());

    if(this.sessionService.getState() == "TIMED_OUT")
    { */
    // this.resetTimeOut("init");
    /*  } */

    //this.sessionService.setIdleObject(this.idle);

    //this.resetTimeOut();

    // this.resetTimeOut();


  }

  saveSecQuestion() {
    const obj = {
      secQuestionOne: this.secQuestionOne,
      secQuestionThree: this.secQuestionThree,
      secQuestionTwo: this.secQuestionTwo,
      secQusAnswerOne: this.secQusAnswerOne,
      secQusAnswerThree: this.secQusAnswerThree,
      secQusAnswerTwo: this.secQusAnswerTwo
    }

    this.Userservice.saveSecQuesAns(this.currentUser.item.userAccountId, obj)
      .subscribe(data => {
        this.showloader = true;
        if (data.status == "Success") {
          this.toast.success(this.Userservice.translateText('hospital_portal.disp_messages.question_saved.success'), '', {
            timeOut: this.timealert
          })
          this.Userservice.logAudit("saveSecQuesAns", 0).subscribe(data => { })
          this.Userservice.setAuth(this.currentUser);
        }
        else {
          this.toast.error(this.Userservice.translateText('patient_portal.display_messages.invalid_data.error'), '', {
            timeOut: this.timealert
          })
        }
      })
  }

  call() {
    alert(this.secQuestionOne)
  }

  getSecretQue() {
    this.Userservice.getSecQuesAns(this.currentUser.item.userAccountId)
      .subscribe(data => {
        if (data.secQuestionIdOne) {
          this.Select.quest1 = data.secQuestionIdOne
          this.Select.quest2 = data.secQuestionIdTwo
          this.Select.quest3 = data.secQuestionIdThree
          this.Select.answer1 = data.secQusAnswerOne
          this.Select.answer2 = data.secQusAnswerTwo
          this.Select.answer3 = data.secQusAnswerThree


          // //console.log("Edit Ques",data)
          this.changeques(this.Select.quest1, 0);
        }
      })
  }
  selectques2: any;
  changeques(eve, qus) {
    if (qus == 0) {
      this.Select.quest1 = eve;
    }
    if (qus == 1) {
      this.Select.quest1 = eve;
      this.Select.answer1 = '';
    } else if (qus == 2) {
      this.Select.quest2 = eve;
      this.Select.answer2 = '';
    } else if (qus == 3) {
      this.Select.quest3 = eve;
      this.Select.answer3 = '';
    }
    const d1 = _.reject(this.question, (o: any): any => { return o.userSecQuestionsId == this.Select.quest1 })
    this.selectques2 = _.reject(d1, (o: any): any => { return o.userSecQuestionsId == this.Select.quest2 })
    this.selectques1 = _.reject(d1, (o: any): any => { return o.userSecQuestionsId == this.Select.quest3 })
    const ss = _.reject(this.question, (o: any): any => { return o.userSecQuestionsId == this.Select.quest3 })
    this.selectques = _.reject(ss, (o: any): any => { return o.userSecQuestionsId == this.Select.quest2 })
  }



  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }

  focus(event, id) {
    if (event) {
      $(`#${id}`).addClass('shown')
    }

  }
  outfocus(event, id) {
    if (event) {
      $(`#${id}`).removeClass('shown')
    }

  }
  modalRef: BsModalRef;
  passwordmatch(pas, passchange) {
    // ////console.log(pas.value.newpass)
    let patvalue = {
      "randId": this.params.id,
      "newpswd": pas.value.newpass
    }
    if (pas.value.newpass == pas.value.newpass2) {
      this.patientservice.lastpass(this.currentUser.item.userAccountId, pas.value.newpass)
        .subscribe(
          data => {
            if (data.status != 'failure') {
              this.patientservice.passchange(patvalue)
                .subscribe(
                  data => {
                    if ((data.message.toLowerCase()) == 'true') {
                      this.patientservice.pwdHistroy(this.currentUser.item.userAccountId, pas.value.newpass)
                        .subscribe(data => { })
                      this.Userservice.logAudit('getUserPassWordUpdate', 0).subscribe(data => { })
                      this.routers.navigate([`/questions/${this.params.id}`])
                    }
                    else {
                      this.resdata = this.Userservice.translateText('patient_portal.display_messages.something_went_wrong');
                      this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
                    }


                  })
            }
            else {
              this.resdata = data.message;
              this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
            }
          })
    }
    else {
      this.resdata = this.Userservice.translateText('patient_portal.validations.confirm_pwd_does_not_match.error');
      this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
    }
  }


  onKey(event: any) {
    var letters = /[a-z,A-Z]/g;
    var lowerCaseLetters = /[a-z]/g;
    var upperCaseLetters = /[A-Z]/g;
    var numbers = /[0-9]/g;
    var special = /[#$^+=!*()@%&]/g;
    if (event.target.value.match(lowerCaseLetters)) {
      this.passval = true
    }
    else {
      this.passval = false
    }
    if (this.userGroup) {
      if (event.target.value.match(letters)) {
        this.passval1 = true
      }
      else {
        this.passval1 = false
      }
    } else {
      if (event.target.value.match(upperCaseLetters)) {
        this.passval1 = true
      }
      else {
        this.passval1 = false
      }
    }
    if (event.target.value.match(numbers)) {
      this.passval2 = true
    }
    else {
      this.passval2 = false
    }
    if (event.target.value.length >= 8) {
      this.passval3 = true
    }
    else {
      this.passval3 = false
    }
    if (event.target.value.match(special)) {
      this.passval4 = true
    }
    else {
      this.passval4 = false
    }

  }
  onKey1(event: any) {
    var letters = /[a-z,A-Z]/g;
    var lowerCaseLetters = /[a-z]/g;
    var upperCaseLetters = /[A-Z]/g;
    var numbers = /[0-9]/g;
    var special = /[#$^+=!*()@%&]/g;
    if (event.target.value.match(lowerCaseLetters)) {
      this.passkey = true
    }
    else {
      this.passkey = false
    }
    if (this.userGroup) {
      if (event.target.value.match(letters)) {
        this.passkey1 = true
      }
      else {
        this.passkey1 = false
      }
    }
    else {
      if (event.target.value.match(upperCaseLetters)) {
        this.passkey1 = true
      }
      else {
        this.passkey1 = false
      }
    }
    if (event.target.value.match(numbers)) {
      this.passkey2 = true
    }
    else {
      this.passkey2 = false
    }
    if (event.target.value.length >= 8) {
      this.passkey3 = true
    }
    else {
      this.passkey3 = false
    }
    if (event.target.value.match(special)) {
      this.passkey4 = true
    }
    else {
      this.passkey4 = false
    }


  }


  useAccountId: any;
  oldpass: any;
  ques(qa, passchange) {

    this.showloader = true;
    // ////console.log(pas.value.newpass)

    let passvalue = {
      'oldPassword': this.oldpass,
      'newPassword': qa.value.newpass,
      'confirmPassword': qa.value.newpass2
    }
    if (qa.value.newpass == qa.value.newpass2) {
      this.userpass = qa.value.newpass
      this.patientservice.lastpass(this.currentUser.item.userAccountId, qa.value.newpass)
        .subscribe(
          data1 => {
            if (data1.status != 'failure') {
              this.Userservice.chagepassword(passvalue, this.currentUser.item.userAccountId)
                .subscribe(
                  data => {

                    if (data.item.status == "success") {
                      this.patientservice.pwdHistroy(this.currentUser.item.userAccountId, qa.value.newpass)
                        .subscribe(data => { })
                      this.Userservice.logAudit("chagepassword", 0).subscribe(data => { })

                      //  this.userService.logAudit('getUserPassWordUpdate',0).subscribe(data=>{})
                      let ans = {
                        //"userAccountId": this.patid,
                        "secQuestionOne": qa.value.quest1 ? qa.value.quest1 : '',
                        "secQuestionTwo": qa.value.quest2 ? qa.value.quest2 : '',
                        "secQuestionThree": qa.value.quest3 ? qa.value.quest3 : '',
                        "secQusAnswerOne": qa.value.answer1 ? qa.value.answer1 : '',
                        "secQusAnswerTwo": qa.value.answer2 ? qa.value.answer2 : '',
                        "secQusAnswerThree": qa.value.answer3 ? qa.value.answer3 : ''
                      }
                      ////console.log(ans)

                      if (this.currentUser.item.userGroupId != 19 && this.currentUser.item.userGroupId != 20) {
                        this.Userservice.saveSecQuesAns(this.currentUser.item.userAccountId, ans)
                          .subscribe(data => {
                            this.showloader = false;
                            if (data.status == "Success") {

                              this.Userservice.logAudit("saveSecQuesAns", 0).subscribe(data => { })
                              this.toast.success(this.Userservice.translateText('hospital_portal.disp_messages.pwd_reset_success.success'), '', {
                                timeOut: this.timealert
                              })
                              let credentials = {
                                'username': this.currentUser.item.userId,
                                'password': btoa(this.userpass),
                                'captcha': '',
                                'mode': '',
                                'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'c',
                                'forcelogin': 'true'
                              }
                              this.Userservice.resetPassvalue = true
                              this.Userservice.attemptAuth(credentials)
                                .subscribe(
                                  data => {

                                  })
                            }
                            else {
                              this.toast.error(this.Userservice.translateText('patient_portal.display_messages.invalid_data.error'), '', {
                                timeOut: this.timealert
                              })
                            }

                          }
                          )
                      } else {
                        this.toast.success(this.Userservice.translateText('hospital_portal.disp_messages.pwd_reset_success.success'), '', {
                          timeOut: this.timealert
                        })
                        let credentials = {
                          'username': this.currentUser.item.userId,
                          'password': btoa(this.userpass),
                          'captcha': '',
                          'mode': '',
                          'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'c',
                          'forcelogin': 'true'
                        }
                        this.Userservice.resetPassvalue = true
                        this.Userservice.logoutuser(this.currentUser.item.userAccountId)
                        this.Userservice.attemptAuth(credentials).subscribe();
                      }
                    }
                    else {
                      this.showloader = false;
                      this.toast.error(data.item.message, '', {
                        timeOut: this.timealert
                      })
                    }


                  })
            } else {
              this.showloader = false;
              this.invalidpass = data1.message
            }


          })

    }
    else {
      this.showloader = false;
      this.resdata = this.Userservice.translateText('patient_portal.validations.confirm_pwd_does_not_match.error');
      this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
    }


    /* if(this.resetdata == "Success"){
      
        ////console.log(qa.value)
        qa.value.newpass
        qa.value.newpass2
        let ans={
          
          "secQuestionOne": qa.value.quest1,
          "secQuestionTwo": qa.value.quest2,
          "secQuestionThree": qa.value.quest3,
          "secQusAnswerOne": qa.value.answer1,
          "secQusAnswerTwo": qa.value.answer2,
          "secQusAnswerThree": qa.value.answer3
        }
        ////console.log(ans)
        
        this.patientservice
        .getquesti(ans,this.patid)
        .subscribe(
          data =>
          {
            ////console.log(data)
            ////console.log("userid",this.myobj.userGroupId)
             if(data == true){
              if(this.myobj.userGroupId == 19 || this.myobj.userGroupId == 20){
                this.toast.success("Security questions saved successfully")
            
            this.routers.navigate([`/upload`])    
          }
              else{
                this.toast.success("Security questions saved successfully")
           
               this.routers.navigate([`/upload`])
              }
            
             }
            else {
             this.toast.error("INVALID DATA")
            }
          }
        )
        } */
  }
  getpassword() {
    let self = this;
    self.patientservice.getPatientPassword(this.currentUser.item.userId, self.currentUser.item.userAccountId)
      .subscribe(data => {
        ////console.log(data)
        if (data.item.status == 'success') {
          this.oldpass = atob(data.item.pwd)
          self.Userservice.logAudit('getPassword', 0)

        }
      })
  }


  validateAnswer1: boolean = false;
  validateAnswer2: boolean = false;
  validateAnswer3: boolean = false
  validateSecurityQuestion(value, qNo: number) {
    if (qNo == 1)
      this.validateAnswer1 = this.validateContainsCharacter(value) || value.length < 4;
    if (qNo == 2)
      this.validateAnswer2 = this.validateContainsCharacter(value) || value.length < 4;
    if (qNo == 3)
      this.validateAnswer3 = this.validateContainsCharacter(value) || value.length < 4;
  }
  validateContainsCharacter(value) {
    let isContains: boolean = false;
    for (const character of ['123', 'password', 'admin', 'test', 'email', this.currentUser.item.firstName, this.currentUser.item.lastName, this.currentUser.item.email]) {
      if (value.toLowerCase().includes(character.toLowerCase())) {
        isContains = true;
        break;
      }
    }
    return isContains;
  }
}